<template>
  <div class="related-posts">
    <post-grid-card
      v-for="post in modifiedRelatedPosts"
      :key="post.id"
      :post="post"
    />
  </div>
</template>
<script>
import {mapState} from "vuex";
import {stripTypenames} from "seu-frontend/services/utils.js";
import PostGridCard from "seu-frontend/modules/blog/components/PostGridCard.vue";

export default {
  name: "RelatedPosts",
  components: {PostGridCard},
  props: {
    posts: {
      type: Object,
      required: true
    }
  },
  computed: {
    ...mapState('post', ["pagination", "relatedPosts"]),

    modifiedRelatedPosts() {
      return this.relatedPosts.length > 2 ? this.relatedPosts.slice(0,2) : this.relatedPosts
    }
  },
  methods: {
    listRelatedPosts() {
      return this.$store.dispatch('post/listRelatedPosts', {
        id: this.post.id,
        lang: this.post.details.lang,
        pagination: {
          page: this.pagination.page,
          rowsPerPage: this.pagination.rowsPerPage,
          sortBy: stripTypenames(this.pagination.sortBy)
        },
      })
    }
  },
  created() {
    this.listRelatedPosts()
  }
}
</script>
<style lang="scss">
@import "RelatedPosts";
</style>
